export default __webpack_public_path__ + "static/media/gallery_04.0afd40b5.jpg";